/* ZETAW — Collection feed (warp): picks the pieces (random or newest), feeds the warp, and the See all button */
(function(){
  'use strict';
  function shuffle(a){ for (var i = a.length - 1; i > 0; i--){ var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function listTarget(root){
    var el = document.getElementById('zr-list') || document.getElementById('ProductGridContainer');
    if (el) return el;
    el = document.querySelector('[id$="__product-grid"], [id*="product-grid"]');
    if (el) return el;
    var sec = root.closest('.shopify-section') || root;
    el = sec.nextElementSibling;
    while (el && !el.offsetHeight) el = el.nextElementSibling;
    return el;
  }
  function toList(root){
    var t = listTarget(root); if (!t) return false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }

  function init(root){
    if (!root || root._zcw) return; root._zcw = true;
    var pool = [];
    try { pool = JSON.parse((root.querySelector('[data-zcw-pool]') || {}).textContent || '[]').filter(Boolean); } catch (e) {}
    var count = parseInt(root.dataset.count, 10) || 8;
    var newest = root.dataset.mode === 'newest';
    /* a deck: every piece of the pool comes up once before any repeats */
    var deck = newest ? pool.slice() : shuffle(pool.slice()), at = 0, pulls = 0;
    function draw(){
      if (at >= deck.length){ deck = newest ? pool.slice() : shuffle(pool.slice()); at = 0; }
      var out = deck.slice(at, at + count); at += count;
      if (out.length < count && deck.length > count){ out = out.concat(deck.slice(0, count - out.length)); }
      pulls++;
      return out;
    }
    var picked = draw();
    var itemsEl = root.querySelector('[data-zw-items]');
    if (itemsEl) itemsEl.textContent = JSON.stringify(picked);
    var go = function(){ if (window.ZetawWarp) window.ZetawWarp.init(root); else setTimeout(go, 50); };
    if (picked.length) go(); else root.classList.add('is-fallback');

    /* HUD reload: pull the next pieces into the feed */
    var pull = root.querySelector('[data-zcw-pull]'), pullTxt = pull && pull.querySelector('[data-zcw-pull-txt]'), busy = false;
    function label(){
      if (!pullTxt) return;
      pullTxt.textContent = (pull.dataset.label || 'Reload for others') + ' // Pull ' + String(pulls).padStart(2, '0') + ' · ' + Math.min(at, pool.length) + '/' + pool.length;
    }
    if (pull){
      if (pool.length <= count) pull.hidden = true;
      label();
      pull.addEventListener('click', function(){
        if (busy || !root._zwSet) return;
        busy = true; pull.classList.add('is-busy'); root.classList.add('is-pulling');
        if (pullTxt) pullTxt.textContent = pull.dataset.busy || 'Pulling new files…';
        setTimeout(function(){
          var list = draw();
          root._zwSet(list, newest ? 0 : null);
          label();
          setTimeout(function(){ busy = false; pull.classList.remove('is-busy'); root.classList.remove('is-pulling'); }, 380);
        }, 260);
      });
    }

    var all = root.querySelector('[data-zcw-all]');
    if (all) all.addEventListener('click', function(e){
      var url = all.getAttribute('href').split('#')[0];
      if (url && location.pathname.replace(/\/$/, '') !== url.replace(/\/$/, '')) return;
      if (toList(root)) e.preventDefault();
    });
    if (location.hash === '#zr-list') setTimeout(function(){ toList(root); }, 350);
  }

  function boot(scope){ Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zetaw-cwarp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
